import { Link } from "react-router-dom";
import type { Collection } from "@/mocks/collections";
import { getCategory } from "@/lib/content";

interface CollectionCardProps {
  collection: Collection;
  variant?: "default" | "wide";
}

export default function CollectionCard({
  collection,
  variant = "default",
}: CollectionCardProps) {
  const category = getCategory(collection.category);

  return (
    <article className="group h-full">
      <Link
        to={`/collections/${collection.id}`}
        className="flex flex-col h-full bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors"
      >
        <div
          className={`relative w-full overflow-hidden bg-background-200 ${
            variant === "wide" ? "h-56 md:h-72" : "h-48"
          }`}
        >
          <img
            src={collection.cover}
            alt={`${collection.title} 合集封面`}
            title={`${collection.title} 私拍吃瓜合集`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
          />
          {category && (
            <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-background-50/95 text-xs font-medium text-primary-700">
              {category.name}
            </span>
          )}
          {collection.hot && (
            <span className="absolute top-3 right-3 px-2.5 py-1 rounded-md bg-accent-500 text-xs font-medium text-secondary-950 flex items-center gap-1">
              <i className="ri-fire-line" aria-hidden="true" />
              热
            </span>
          )}
        </div>

        <div className="flex flex-col flex-1 p-4 md:p-5">
          <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 leading-snug group-hover:text-primary-700 transition-colors line-clamp-2">
            {collection.title}
          </h3>
          <p className="text-sm text-foreground-600 leading-relaxed mt-2.5 line-clamp-2 flex-1">
            {collection.summary}
          </p>
          <div className="flex items-center flex-wrap gap-x-4 gap-y-1 mt-4 pt-3 border-t border-background-200 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-calendar-line" aria-hidden="true" />
              {collection.date}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line" aria-hidden="true" />
              {collection.readTime}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line" aria-hidden="true" />
              {collection.views}
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
}